import { Select, Spin } from 'antd';
import debounce from 'lodash/debounce';
import PropTypes from 'prop-types';
import React, { useEffect, useMemo, useRef, useState } from 'react';
import { searchVendors } from '../../api/vendor/vendor.js';

function VendorSelect({ value = null, onChange, currentSelection = {}, mode, ...otherProps }) {
    const debounceTimeout = 500;
    const selectedOption = currentSelection?.value && currentSelection.value === value ? [{ value: currentSelection?.value, label: currentSelection?.label }] : [];
    const [fetching, setFetching] = useState(false);
    const [options, setOptions] = useState(selectedOption);
    const fetchRef = useRef(0);

    const loadOptions = (searchVal = '') => {
        fetchRef.current += 1;
        const fetchId = fetchRef.current;
        setFetching(true);
        searchVendors(searchVal).then((newOptions) => {
            if (fetchId !== fetchRef.current) {
                return;
            }
            if (selectedOption.length > 0 && !newOptions.some(({ value }) => value === currentSelection.value)) {
                setOptions([...selectedOption, ...(newOptions || [])]);
            } else {
                setOptions(newOptions || []);
            }
            setFetching(false);
        }).catch(() => {
            setFetching(false);
        });
    };

    useEffect(() => {
        loadOptions('');
    }, []);

    const debounceFetcher = useMemo(() => {
        return debounce((val) => loadOptions(val), debounceTimeout);
    }, [currentSelection, debounceTimeout]);

    return (
        <Select
            mode={mode}
            filterOption={false}
            onSearch={debounceFetcher}
            notFoundContent={fetching ? <Spin size="small" /> : null}
            options={options}
            onChange={onChange}
            value={value}
            placeholder={mode === 'multiple' ? 'Search and select vendor(s)' : 'Select Vendor'}
            showSearch
            allowClear
            maxTagCount="responsive"
            {...otherProps}
        />
    );
}

VendorSelect.propTypes = {
    value: PropTypes.oneOfType([PropTypes.number, PropTypes.string, PropTypes.array]),
    onChange: PropTypes.func,
    mode: PropTypes.string,
    currentSelection: PropTypes.shape({
        id: PropTypes.number,
        company: PropTypes.string,
        value: PropTypes.number,
        label: PropTypes.string,
    })
}

export default VendorSelect;